import React, { useContext } from "react";
import { FaSort, FaBroom, FaClipboardCheck, FaSyncAlt, FaLayerGroup } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import "../TrainingGlobal.css";
import BannerImage from "./worker2.webp";

const SConcept: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/5s');
    } else {
      navigate('/login', { state: { from: '/booking/5s' } });
    }
  };

  return (
    <div className="training-page">
      <div className="training-max-width">

        {/* --- HERO --- */}
        <div className="training-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Workplace Organization</span>
          <h1 className="hero-title">5S Methodology & Concepts</h1>
          <p className="hero-subtitle">
            A place for everything, and everything in its place.
            How the 5S system reduces waste, improves efficiency, and enhances safety.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">What is 5S?</h2>
              <p className="article-text">
                Originating from Japan (Toyota Production System), 5S is more than just cleaning—it's
                a mindset of discipline. A cluttered workspace hides hazards and creates inefficiency.
                5S brings problems to the surface.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">The 5 Pillars</h2>
              <ul style={{ listStyle: 'none', padding: 0, marginTop: '20px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
                <li style={{ background: '#111', padding: '15px', borderRadius: '8px', borderLeft: '3px solid #FF6B00' }}>
                  <strong style={{ color: '#fff', fontSize: '1.1rem' }}>1. Seiri (Sort)</strong>
                  <p style={{ color: '#888', margin: '5px 0 0' }}>Remove unnecessary items. Use the "Red Tag" system for doubtful items.</p>
                </li>
                <li style={{ background: '#111', padding: '15px', borderRadius: '8px', borderLeft: '3px solid #FF6B00' }}>
                  <strong style={{ color: '#fff', fontSize: '1.1rem' }}>2. Seiton (Set in Order)</strong>
                  <p style={{ color: '#888', margin: '5px 0 0' }}>Organize essential items. Shadow boards, floor marking, and labeling.</p>
                </li>
                <li style={{ background: '#111', padding: '15px', borderRadius: '8px', borderLeft: '3px solid #FF6B00' }}>
                  <strong style={{ color: '#fff', fontSize: '1.1rem' }}>3. Seiso (Shine)</strong>
                  <p style={{ color: '#888', margin: '5px 0 0' }}>Clean the workspace. Cleaning is inspection; it reveals leaks and damage.</p>
                </li>
                <li style={{ background: '#111', padding: '15px', borderRadius: '8px', borderLeft: '3px solid #FF6B00' }}>
                  <strong style={{ color: '#fff', fontSize: '1.1rem' }}>4. Seiketsu (Standardize)</strong>
                  <p style={{ color: '#888', margin: '5px 0 0' }}>Create rules and schedules. Make the first 3 S's a habit.</p>
                </li>
                <li style={{ background: '#111', padding: '15px', borderRadius: '8px', borderLeft: '3px solid #FF6B00' }}>
                  <strong style={{ color: '#fff', fontSize: '1.1rem' }}>5. Shitsuke (Sustain)</strong>
                  <p style={{ color: '#888', margin: '5px 0 0' }}>Self-discipline and audits. Keep the system alive long-term.</p>
                </li>
              </ul>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Benefits for Safety</h2>
              <p className="article-text">
                5S directly impacts safety by removing trip hazards (cables, clutter), reducing
                search time (less frustration/rushing), and identifying equipment defects early (during Shine).
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">5S Checklist</h4>
              <ul className="key-list">
                <li><FaSort className="check-icon" /> Sort & Red Tag</li>
                <li><FaLayerGroup className="check-icon" /> Visual Order</li>
                <li><FaBroom className="check-icon" /> Daily Cleaning</li>
                <li><FaClipboardCheck className="check-icon" /> SOP Creation</li>
                <li><FaSyncAlt className="check-icon" /> Monthly Audits</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Implement 5S</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Transform your workplace efficiency and safety.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SConcept;
